import React, { Fragment } from "react";
import styled from "@emotion/styled";
import { Wrapper } from "Components/Common/Wrapper/index";
import { LabelT1, LabelT2, LabelT3 } from "Components/Common/Label/index";
import { Spacer } from "Components/Common/Spacer/index";
import SelectT1 from "Components/Common/Select/SelectT1";
import { ButtonT2, ButtonT4 } from "Components/Common/Button/index";
import { ReactComponent as DownloadIconT1 } from "Icons/downloadIconT1.svg";
import { DateRangePicker } from "react-dates";
import InputT1 from "Components/Common/Input/InputT1";
import RenderPaginationButtons from "./pagination";

const InprogressAndCompletedFilterBox = (props) => {
  const {
    selectedTab,
    sourcePortList,
    destinationPortList,
    statusList,
    handleDownloadEximContainerBlTrackingDetailsTemplateFile,
    handleFilterBoxOnChange,
    filter,
    blNumbers,
    trackingCount,
    goToPage,
    offset,
    limit,
    categoryList,
    fromDate,
    toDate,
    onDatesChange,
    focusedInput,
    onDateFocusChange
  } = props;
  return (
    <Fragment>
      <InprogressAndCompletedFilterBoxWrapper>
        <LeftSideWrapper>
          <Wrapper>
            <LabelT3>Search </LabelT3>
            <Spacer spacing={"2px"} />
            <InputT1 
              placeholder={"Search..."}
              onChange={(e) => handleFilterBoxOnChange(e.target.value, "containerNumber")}
              value={filter.containerNumber}
           />
          </Wrapper>
          <Wrapper>
            <LabelT3>Date Range </LabelT3>
            <Spacer spacing={"2px"} />
            <DateRangePicker
              disabled={false}
              startDate={fromDate}
              startDateId="startDate"
              endDate={toDate}
              endDateId="endDate"
              onDatesChange={({ startDate, endDate }) => {
                onDatesChange(startDate, endDate);
              }}
              focusedInput={focusedInput}
              onFocusChange={focusedInput =>{onDateFocusChange(focusedInput)}}
              displayFormat={'DD MMM YYYY'}
              noBorder={true}
              minimumNights={0}
              isOutsideRange={(date) => false}
              isClearable={true}
            />
          </Wrapper>
          <Wrapper>
            <LabelT3>BL Number</LabelT3>
            <Spacer spacing={"2px"} />
            <SelectT1
              options={blNumbers}
              isClearable={true}
              value={filter.blNumber}
              onChange={(data) => {
                handleFilterBoxOnChange(data, "blNumber");
              }}
            />
          </Wrapper>
          {selectedTab === 2 && (
            <Wrapper>
              <LabelT3>Status</LabelT3>
              <Spacer spacing={"2px"} />
              <SelectT1
                options={statusList}
                isClearable={true}
                value={filter.status}
                onChange={(data) => {
                  handleFilterBoxOnChange(data, "status");
                }}
              />
            </Wrapper>
          )}
          <Wrapper>
            <LabelT3>From Port </LabelT3>
            <Spacer spacing={"2px"} />
            <SelectT1
              options={sourcePortList}
              isClearable={true}
              value={filter.source}
              onChange={(data) => {
                handleFilterBoxOnChange(data, "source");
              }}
            />
          </Wrapper>
          <Wrapper>
            <LabelT3>To Port </LabelT3>
            <Spacer spacing={"2px"} />
            <SelectT1
              options={destinationPortList}
              isClearable={true}
              value={filter.destination}
              onChange={(data) => {
                handleFilterBoxOnChange(data, "destination");
              }}
            />
          </Wrapper>
          <Wrapper>
            <LabelT3>Category </LabelT3>
            <Spacer spacing={"2px"} />
            <SelectT1
              options={categoryList}
              isClearable={true}
              value={filter.categoryName}
              onChange={(data) => {
                handleFilterBoxOnChange(data, "categoryName");
              }}
            />
          </Wrapper>
          
        </LeftSideWrapper>
        <RightSideWrapper>
          {/* <ButtonT2
            onClick={handleDownloadEximContainerBlTrackingDetailsTemplateFile}
          >
            <DownloadIconT1 />
            Downlaod
          </ButtonT2> */}
        </RightSideWrapper>
      </InprogressAndCompletedFilterBoxWrapper>
    </Fragment>
  );
};

export default InprogressAndCompletedFilterBox;

const InprogressAndCompletedFilterBoxWrapper = styled("div")`
  border-radius: 6px;
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.04) 0%,
      rgba(0, 0, 0, 0.04) 100%
    ),
    #e3e9ff;

  padding: 15px;

  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
`;

const LeftSideWrapper = styled(Wrapper)`
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
`;
const RightSideWrapper = styled(Wrapper)`
  display: flex;
`;
